import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useSharedContext } from '@office-start/context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useIdentity } from '@office-start/identity-service';
import { useCallback, useMemo } from 'react';
import { executeUploadFlow as executeUploadFlowInternal } from '../operations/executeUploadFlow';
import { useUploadConfig } from './useUploadConfig';
export function useUploadFile() {
    var uploadConfig = useUploadConfig().data;
    var componentContext = useOfficeComponentContext().data;
    var sharedContext = useSharedContext().data;
    var identity = useIdentity().data;
    var featureGates = useFeatureGates().data;
    var graphXhrOptions = useMemo(function () {
        if (!componentContext || !identity || !sharedContext) {
            return undefined;
        }
        return {
            correlationId: componentContext.correlationId,
            getAccessToken: componentContext.getAccessToken,
            jwtAuthEnabled: componentContext.jwtAuthEnabled,
            officeApiRoot: componentContext.officeHomeApiRoot,
            graphApiRoot: sharedContext.graphApiRoot,
        };
    }, [componentContext, identity, sharedContext]);
    var executeUploadFlow = useCallback(function (fileUploadState, updateFileUploadState) {
        return executeUploadFlowInternal({
            componentContext: componentContext,
            featureGates: featureGates,
            fileUploadState: fileUploadState,
            graphXhrOptions: graphXhrOptions,
            uploadConfig: uploadConfig,
            updateFileUploadState: updateFileUploadState,
        });
    }, [componentContext, featureGates, graphXhrOptions, uploadConfig]);
    return executeUploadFlow;
}
//# sourceMappingURL=useUploadFile.js.map